module.exports = __webpack_public_path__ + "img/cross.be6fa227.svg";